import React, { FC, useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../states/containers/store'
import { endOfMonth, format, nowDate, startOfMonth, yesterDay } from '../../../utils/date'

interface Props {
  name: string
  date: string
  teamIds: number[]
  memberIds: number[]
}

const SearchConditionModule: FC<Props> = (props) => {
  const {
    name,
    date,
    teamIds,
    memberIds,
  } = props

  const {
    commonPart,
    memberList,
    login,
  } = useSelector((state: RootState) => state)

  const endDate = useMemo(() => {
    if (Number(format(date, "YYYYMM")) === Number(nowDate("YYYYMM"))) {
      return yesterDay("YYYY-MM-DD")
    }
    return endOfMonth(date, "YYYY-MM-DD")
  }, [date])

  const [isDisplaySticky, setIsDisplaySticky] = useState(false)

  const scrollTop = (): number => Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop)

  const onScroll = (): void => {
    if (scrollTop() <= 800) {
      setIsDisplaySticky(false)
    } else {
      setIsDisplaySticky(true)
    }
  }

  const body = () => (
    <>
      <div className="search_condition_title">
        絞り込み条件
      </div>
      <div className="chip_wrap">
        <div className="chip_area">
          <div>
            期間：
          </div>
          <div className="chip">
            {startOfMonth(date, "YYYY-MM-DD")}
            &nbsp;~&nbsp;
            {endDate}
          </div>
        </div>
        {
          teamIds.length ? (
            <div className="chip_area">
              <div>
                チーム：
              </div>
              <div className="chip_list">
                {
                  commonPart.teams?.filter((team) => teamIds.includes(team.id)).map((team) => (
                    <div
                      key={`search_condition_team_${team.id}`}
                      className="chip"
                    >
                      {team.name}
                    </div>
                  ))
                }
              </div>
            </div>
          ) : (
            <></>
          )
        }
        {
          memberIds.length ? (
            <div className="chip_area">
              <div>
                ユーザー：
              </div>
              <div className="chip_list">
                {
                  memberList.members?.filter((member) => memberIds.includes(member.id)).map((member) => (
                    <div
                      key={`search_condition_member_${member.id}`}
                      className="chip"
                    >
                      {member.name}
                    </div>
                  ))
                }
              </div>
            </div>
          ) : (
            <></>
          )
        }
      </div>
    </>
  )

  useEffect(() => {
    if (!login.accessToken) return
    document.addEventListener("scroll", onScroll)
    // eslint-disable-next-line no-unused-expressions
    document.querySelector('html')?.classList.add('scroll_contents')
  }, [login.accessToken])

  return (
    <>
      <section className={`sticky_header ${isDisplaySticky && "active"}`}>
        <div>
          <div className="sticky_header_title">
            {name}
          </div>
          {body()}
        </div>
      </section>
      <section className="search_condition">
        {body()}
      </section>
    </>
  )
}

export default SearchConditionModule
